import { useSearchResults } from '@/features/header/hooks/useSearchResults';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface SearchResultsProps {
  query: string;
  onSelect: () => void;
}

export const SearchResults = ({ query, onSelect }: SearchResultsProps) => {
  const { t } = useTranslation();
  const results = useSearchResults(query);

  if (results.length === 0) {
    return (
      <div className="text-md flex h-10 items-center justify-center p-3 text-center font-semibold">
        {query.trim() ? t('label.nothingFound') : t('label.emptyQuery')}
      </div>
    );
  }

  return (
    <ul className="scrollbar-none max-h-80 overflow-y-auto rounded-lg bg-white py-1">
      {results.map((item, index) => (
        <li key={`${item.to}-${String(index)}`}>
          <Link
            to={item.to}
            onClick={() => {
              onSelect();
            }}
            className={cn('flex cursor-pointer items-center justify-between text-sm transition-colors')}
          >
            <div className="mx-1 flex w-full items-center overflow-hidden rounded-sm px-4 py-1.5 hover:bg-neutral-100">
              <div className="flex max-w-34 min-w-34 items-center gap-2 overflow-hidden font-bold">
                <span className="flex items-center justify-center">{item.icon}</span>
                <span className="truncate" title={item.category}>
                  {item.category}
                </span>
              </div>
              <div className="mx-3 h-3.5 w-px bg-neutral-300" />
              <span className="truncate" title={item.label}>
                {item.label}
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
};
